module.exports = __webpack_public_path__ + "static/media/41_A.d51d89b4.png";